import { defineStore } from 'pinia'
import { reportWarning } from '../utils/reporting'

function isValidEntry(entry) {
  if (entry === null || entry === undefined) return true
  if (typeof entry !== 'object' || Array.isArray(entry)) return false
  const idType = typeof entry.id
  const nameType = typeof entry.name
  return (idType === 'string' || idType === 'number') && nameType === 'string'
}

export const useHelpCenterStore = defineStore('helpCenter', {
  state: () => ({
    currentCategory: null,
    currentSection: null,
    currentArticle: null,
  }),

  actions: {
    setCurrentCategory(category) {
      this.currentCategory = category
      this.saveState()
    },
    setCurrentSection(section) {
      this.currentSection = section
      this.saveState()
    },
    setCurrentArticle(article) {
      this.currentArticle = article
      this.saveState()
    },
    saveState() {
      localStorage.setItem('helpCenterState', JSON.stringify({
        currentCategory: this.currentCategory,
        currentSection: this.currentSection,
        currentArticle: this.currentArticle
      }))
    },
    loadState() {
      const saved = localStorage.getItem('helpCenterState')
      if (!saved) return

      try {
        const state = JSON.parse(saved)
        if (!isValidEntry(state?.currentCategory) ||
            !isValidEntry(state?.currentSection) ||
            !isValidEntry(state?.currentArticle)) {
          throw new Error('corrupted persisted state')
        }
        this.currentCategory = state.currentCategory ?? null
        this.currentSection = state.currentSection ?? null
        this.currentArticle = state.currentArticle ?? null
      } catch (err) {
        reportWarning('helpCenter: removing corrupted persisted state', {
          reason: err.message,
          rawValue: saved?.slice(0, 500)
        })
        localStorage.removeItem('helpCenterState')
      }
    },
  },
})
